// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2bhxR","search":"Settings_search__20fuI","filter":"Settings_filter__1TqYI"};